import {
  ITableFields,
  TABLE_FIELD_ALIGN,
  TABLE_FIELD_TYPE,
} from "../../core-component/ui/ICTable";
import { IPagination } from "../../data/AppInterface";
import {
  TReactSetState,
  TSetPaginationFn,
  TUseTranslationTfn,
} from "../../data/AppType";
import {
  DELETE_MEASUREMENT_FIELD,
  GET_ALL_MEASUREMENT_FIELD,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  handleError,
  sweetAlertError,
  sweetAlertSuccess,
} from "../../utils/AppFunctions";

export interface IMeasurementField {
  id: string;
  measurement_field_name: string;
  measurement_unit: string;
  measurement_unit_label: string;
  created_by: string;
  created_date: string;
  modified_by: string | null;
  modified_date: string | null;
}

export function getMeasurementFields<T>(
  actionComponent: (item: T) => JSX.Element,
  t: TUseTranslationTfn
): ITableFields<T>[] {
  return [
    {
      name: t("measurement_field_name"),
      key: "measurement_field_name",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-3",
    },
    {
      name: t("measurement_unit"),
      key: "measurement_unit_label",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },

    {
      name: t("created_by"),
      key: "created_by",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("created_date"),
      key: "created_date",
      sort: true,
      type: TABLE_FIELD_TYPE.date,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },
    {
      name: t("modified_by"),
      key: "modified_by",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("modified_date"),
      key: "modified_date",
      sort: true,
      type: TABLE_FIELD_TYPE.date,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },

    {
      name: t("action"),
      key: "action",
      sort: false,
      type: TABLE_FIELD_TYPE.custom,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-1",
      component: actionComponent,
    },
  ];
}

export const fetchAllMeasurementField = async (
  setMeasurementField: TReactSetState<IMeasurementField[]>,
  pagination: IPagination,
  setPagination: TSetPaginationFn,
  search: string
) => {
  try {
    const measurementField = await GET_ALL_MEASUREMENT_FIELD(
      pagination,
      search
    );
    if (
      measurementField &&
      measurementField.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      setMeasurementField(measurementField.data.items);
      setPagination(measurementField.data.pagination);
    } else {
      setMeasurementField([]);
      sweetAlertError({
        message: measurementField.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (error: any) {
    sweetAlertError({
      message: error.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
    });
    handleError(error, "fetchAllMeasurementField");
  }
};

export const deleteMeasurementField = async (id: string) => {
  try {
    const deletedData = await DELETE_MEASUREMENT_FIELD(id);
    if (deletedData && deletedData.code === DEFAULT_STATUS_CODE_SUCCESS) {
      sweetAlertSuccess({ message: deletedData.message });
      return true;
    } else {
      sweetAlertError({
        message: deletedData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (e: any) {
    sweetAlertError({
      message: e.response.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
    });
    handleError(e, "deleteMeasurementField");
    return false;
  }
};
